

































import { computed, PropType, ref, watch } from 'vue';
import { InstitutionProfileModel } from '../models/institutionProfile.model';
import AulaImg from './AulaImg.vue';
import Icon from './Icon.vue';
import { iconClassEnum } from '../enums/iconClassEnum';
import { textUtil } from '../utils/textUtil';
import { useAvatarScan } from '../composables/useAvatarScan';
import { ScanningStatusEnum } from '../enums/scanningStatus.enum';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Avatar',
  components: { Icon, AulaImg },
  props: {
    profile: { type: Object as PropType<InstitutionProfileModel>, default: null },
    disabled: { type: Boolean, default: false },
    showOverlay: { type: Boolean, default: false },
    shortText: { type: Boolean, default: false },
  },
  setup(props) {
    const isProfileImageError = ref(false);
    const imageUrl = computed(() => props.profile?.profilePicture?.url || props.profile?.profilePictureUrl || '');
    const hasProfileImage = computed(() => Boolean(imageUrl.value));
    const shouldShowProfileImage = computed(() => hasProfileImage.value && !isProfileImageError.value);
    const isBlocked = computed(() => scanningText.value != null && props.showOverlay);

    const profilePictureRef = computed(() => props.profile?.profilePicture || null);
    const scanningText = computed(() => {
      const { scanningText } = useAvatarScan(profilePictureRef, props.shortText ? 'short' : 'long');
      return scanningText.value;
    });

    const name = computed((): string => String(props.profile?.fullName || props.profile?.name || ''));
    const shortName = computed(() => props.profile?.shortName || textUtil.getShortName(name.value));
    const shortNameSize = computed(() => {
      if (shortName.value.length > 3) {
        return 'small';
      }
      if (shortName.value.length < 3) {
        return 'large';
      }
      return '';
    });

    const onProfileImageLoad = () => {
      isProfileImageError.value = false;
    };
    const onProfileImageError = () => {
      isProfileImageError.value = true;
    };

    watch(imageUrl, () => {
      isProfileImageError.value = false;
    });

    return {
      isProfileImageError,
      isBlocked,
      imageUrl,
      hasProfileImage,
      shouldShowProfileImage,
      iconClassEnum,
      name,
      shortName,
      shortNameSize,
      scanningText,
      scanningStatus: profilePictureRef.value?.scanningStatus,
      ScanningStatusEnum,
      onProfileImageLoad,
      onProfileImageError,
    };
  },
});
